import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledIcon = styled.i`
  display: inline;
  height: 2rem;
  color: ${({ theme }) => theme.colors.brandPrimary};
  font-size: 1.875em;
  vertical-align: top;
  justify-content: center;
  margin-right: 0.5rem;
  padding-left: 0.1rem;
  padding-rightf: 0.1rem;
`;

function SupportIcon({ iconType }) {
  return <StyledIcon className={`${iconType}`}></StyledIcon>;
}

SupportIcon.propTypes = {
  iconType: PropTypes.string,
};

SupportIcon.defaultProps = {
  iconType: 'bi bi-check-circle-fill',
};

export default SupportIcon;
